// Role-based UI gates — Feb 2026.
//
// Why this file exists:
//   `useAuth()` populates `user` asynchronously after `/api/auth/me`
//   resolves. Any UI gate that reads `user.role` directly will FLASH
//   the wrong content for ~200ms–2s on every page load (the same leak
//   pattern we fixed for the sidebar tabs). To eliminate the flash, we
//   decode the JWT in `localStorage.token` synchronously on the very
//   first render — JWTs are not signed client-side so we can safely
//   read the `role` claim. This is purely a UX gate; the BACKEND still
//   enforces all role-based authorisation independently.

// Read the user role from the JWT payload in localStorage WITHOUT
// waiting for the auth context. Returns null for guests or if the
// token is malformed / missing.
export function roleFromToken() {
  try {
    if (typeof window === 'undefined') return null;
    const t = localStorage.getItem('token');
    if (!t) return null;
    const parts = t.split('.');
    if (parts.length < 2) return null;
    const b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const pad = b64.length % 4 ? '='.repeat(4 - (b64.length % 4)) : '';
    const payload = JSON.parse(atob(b64 + pad));
    return payload.role || null;
  } catch {
    return null;
  }
}

// AI chat (Ask Unexa) is for STUDENTS and GUESTS only. Agents and
// institutions don't need a student-focused planning assistant — and
// the per-user AI quota gets eaten by the wrong audience otherwise.
export function isAiChatAllowed(role) {
  return role !== 'agent' && role !== 'institution';
}

// Explore tab pills — role-aware visibility.
//   • Agents logged in   → hide the "Agents" pill (they ARE agents)
//   • Institutions in    → hide the "Colleges" pill (they ARE colleges)
//   • Everyone else      → all pills visible
export function isPillAllowed(role, pillKey) {
  if (role === 'agent' && pillKey === 'agents') return false;
  if (role === 'institution' && pillKey === 'colleges') return false;
  return true;
}
